import store from '@/store';

export default {
	async archiveOrRestoreCluster(parent, clusterId, isArchived, notifyZone) {
		try{
				await parent.$confirm(
					isArchived ? 'Are you sure you want to archive the cluster?':'Are you sure you want to restore the archived cluster?',
					'Confirmation',
					'question',
					{
						confirmButtonText: 'Yes',
            cancelButtonText: 'No',
					},
				);
		}
		catch{
			return
		}
		try{
			let response
			response = await store.dispatch('manageClusterArchivalMiddleware', {
									clusterId: clusterId,
									isArchived: isArchived
							});
			if (response) {
					let message = isArchived? 'Cluster archived successfully':'Cluster restored successfully';
					parent.updateShowedElements(true, 'Archived')
					parent.activeClustersHoverActive = false
					parent.favouriteClustersHoverActive = false
					parent.allClustersHoverActive = false
					parent.archivedClustersHoverActive = true
					parent.isLoading = false;
					const successText = message
					const successTitle = 'CLUSTER ARCHIVES MANGEMENT'
					parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.SUCCESS, successTitle, successText, notifyZone)
			}
			else {
					const errText = response.message
					const errTitle = 'Operation Failed'
					parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone)
					return
			}
		}catch{
			const errText = 'Something went wrong in middle of the process'
			const errTitle = 'Operation Failed'
			parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone)
			return
		}
	}
}
